import { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Phone } from 'lucide-react';

export default function NotFound() {
  // Страница отдаётся по адресу /404/ и отвечает 200 — то есть это мягкий 404,
  // который поисковик может проиндексировать как обычную страницу. Канонический
  // адрес ведёт на главную, но этого мало: канонический — подсказка, robots —
  // указание. Мета ставится и в предрендеренный снимок, и при живом переходе.
  useEffect(() => {
    let el = document.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'robots');
      document.head.appendChild(el);
    }
    el.setAttribute('content', 'noindex, follow');
    return () => {
      // Уходя, мету убираем: она относится к этой странице, а не к сайту.
      document.querySelector('meta[name="robots"]')?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 py-32">
        <div className="max-w-2xl text-center">
          <div className="font-display text-[120px] lg:text-[180px] text-gold leading-none mb-4">404</div>
          <h1 className="font-display text-display-2 text-navy mb-5">Page Not Found</h1>
          <p className="font-body text-navy/70 mb-8 max-w-md mx-auto">
            The page you&apos;re looking for has moved or doesn&apos;t exist. If you arrived from a search result, the content may have been
            reorganized. Please return home or call us for assistance.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/" className="btn-navy">Return Home</a>
            <a href="tel:8885291315" className="btn-gold">
              <Phone className="w-4 h-4" />
              Call 888-529-1315
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
